import { DataBean } from "../DataBean";

export class QualityInspectionProductItem extends DataBean {

  public async getQualityInspectionProductItemCatalogPorPropiedades( properties: any, maxRows: number ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getQualityInspectionProductItemCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getQualityInspectionProductItemRender( page: number, rows: number, properties: any ): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getQualityInspectionProductItemRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteQualityInspectionProductItem(idqualityinspectionproductitem: number): Promise<any> {
      return this.getCustomService("ProcessContractERP", "boolean_deleteQualityInspectionProductItem_Number", [idqualityinspectionproductitem]);
  }

  public async updateQualityInspectionProductItem(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.QualityInspectionProductItem_updateQualityInspectionProductItem_com.orange.finance.processcontract.bean.QualityInspectionProductItem",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.QualityInspectionProductItem",
        },
      ]
    );
  }
}
